import { PropsWithChildren } from 'react'

export function ViewGestureHandler({ children }: PropsWithChildren<unknown>): JSX.Element {
  return <>{children}</>
}
